import React from 'react';
import {useForm} from 'react-hook-form';
import CandidateDocuments from '../onlineCvComponents/CandidateDocuments';
import Button from '../../Buttons/Button';
import GateCheckboxComponent from '../../gateCheckbox/GateCheckboxComponent';

export default function RegisterFormAgency(props) {
	const { register, handleSubmit, errors } = useForm();
	const onSubmit = data => props.registerFunction(data);
	const hasError = (name, error) => {
		return error.hasOwnProperty(name);
	};

	let keys = Object.keys(errors);
	if (keys.length > 0) {
		let e = document.getElementById(keys[0]);
		if (e) {
			e.scrollIntoView();
		}
	}

	return (
		<div className={'job-post-form'}>
			<div className={'basic-info-input'}>
				<form onSubmit={handleSubmit(onSubmit)} className={'col-12'}>
					<div className={'row'}>
						<div className={'col-12 col-md-4'}>
							<div className={'form-group'}>
								<select
									name="sex"
									id="sex"
									ref={register({ required: true })}
									className={hasError('sex', errors) ? 'form-control inputHasError' : 'form-control requiredField'}
									defaultValue={props.sex}>
									<option
										value="">{window.Translator.getSlug('FormalAddress', props.language)}</option>
									<option value="0">{window.Translator.getSlug('Mr', props.language)}</option>
									<option value="1">{window.Translator.getSlug('Mrs', props.language)}</option>
								</select>
								{hasError('sex', errors) && <span
									className="form-error-message">{window.Translator.getSlug('ThisFieldIsRequired', props.language)}</span>}
							</div>
						</div>
						<div className={'col-12 col-md-4'}>
							<div className={'form-group'}>
								<input onInput={e => props.checkCandidateExists(e.target.name, e.target.value)}
									   className={hasError('firstName', errors) ? 'form-control inputHasError' : 'form-control requiredField'}
									   type="text"
									   placeholder={window.Translator.getSlug('Firstname', props.language)}
									   name="firstName"
									   id="firstName"
									   ref={register({
										   required: true,
										   maxLength: 100
									   })}
									   defaultValue={props.firstName}/>
								{hasError('firstName', errors) && <span
									className="form-error-message">{window.Translator.getSlug('ThisFieldIsRequired', props.language)}</span>}
							</div>
						</div>
						<div className={'col-12 col-md-4'}>
							<div className={'form-group'}>
								<input onInput={e => props.checkCandidateExists(e.target.name, e.target.value)}
									className={hasError('lastName', errors) ? 'form-control inputHasError' : 'form-control requiredField'}
									type="text" placeholder={window.Translator.getSlug('Lastname', props.language)}
									name="lastName" id="lastName" ref={register({
									required: true,
									maxLength: 100
								})} defaultValue={props.lastName}/>
								{hasError('lastName', errors) && <span
									className="form-error-message">{window.Translator.getSlug('ThisFieldIsRequired', props.language)}</span>}
							</div>
						</div>
						<div className={'col-12 col-md-4'}>
							<div className={'form-group'}>
								<input onInput={e => props.checkCandidateExists(e.target.name, e.target.value)}
									   className={hasError('email', errors) ? 'form-control inputHasError' : 'form-control requiredField'}
									   type="text"
									   placeholder={window.Translator.getSlug('Email', props.language)}
									   ref={register({
										   required: true,
										   pattern: /^\S+@\S+$/i
									   })}
									   name='email'
									   id='email'
									   defaultValue={props.email}/>
								{hasError('email', errors) && <span
									className="form-error-message">{window.Translator.getSlug('ThisFieldIsRequired', props.language)}</span>}
							</div>
						</div>
						<div className={'col-12 col-md-4'}>
							<div className={'form-group'}>
								<input
									className={hasError('phone', errors) ? 'form-control inputHasError' : 'form-control requiredField'}
									type="text"
									placeholder={window.Translator.getSlug('Phone', props.language)}
									name="phone"
									id="phone"
									ref={register({
										required: true,
										minLength: 6,
										maxLength: 20,
										pattern: /[+ ]*[( ]{0,1}[0-9]{1,4}[) ]{0,1}[-\\s\\./0-9]*/i
									})}
									defaultValue={props.phone}/>
								{hasError('phone', errors) && <span
									className="form-error-message">{window.Translator.getSlug('ThisFieldIsRequired', props.language)}</span>}
							</div>
						</div>
						<div className="col-12 col-md-4">
							{props.personalNumber && props.personalNumber !== 'hidden' && props.personalNumber !== 'undefined' && props.personalNumber !== 'null' &&
							<div className="form-group">
								<input
									className={hasError('PersonalNumber', errors) ? 'form-control inputHasError' : 'form-control requiredField'}
									type="text"
									placeholder={window.Translator.getSlug('PersonalNumber', props.language)}
									name="personalNumber"
									ref={register({ required: props.personalNumber === 'required' })}/>
								{hasError('personalNumber', errors) && <span
									className="form-error-message">{window.Translator.getSlug('ThisFieldIsRequired', props.language)}</span>}
							</div>
							}
							<div className="form-group">
								<input className={'form-control '} type="text"
									   placeholder={window.Translator.getSlug('Note', props.language)} name="note"
									   ref={register({ required: false })}/>
							</div>
						</div>
						<div className={'col-12'}>
							<GateCheckboxComponent
								language={props.language}
								customerName={props.customerName}
								register={register} hasError={hasError}
								positionId={props.positionId}
								errors={errors}
								checkboxes={props.checkboxes}
							/>
						</div>
						<div className={'col-12'}>
							<>
								<hr/>
								<div className={'col-12'}>
									<CandidateDocuments language={props.language}
														customerName={props.customerName}
														setUploadQueu={props.setUploadQueu}
									/>
								</div>
								<hr/>
							</>
						</div>
						<div className={'col-10 col-lg-4'}>
							<Button
								className={'btn btn-primary register-button'}
								type={'submit'}
								buttonType={'register-button'}
								positionId={props.positionId}
								customerName={props.customerName}
							>
								{window.Translator.getSlug('Send', props.language)}
							</Button>
						</div>
					</div>
				</form>
			</div>
		</div>
	);
}



